import type { PropsWithChildren } from 'react';
import React from 'react';

import { IconNames, type IconName } from '../../element/Icon/icon.types';
import type { colors } from '../../../theme/axiom-theme';
import { CondensedLarge } from '../../content/CondensedLarge/CondensedLarge';
import { CondensedMedium } from '../../content/CondensedMedium/CondensedMedium';
import { Flashy } from '../../element/Flashy/Flashy';
import { Icon } from '../../element/Icon/Icon';
import { Layout } from '../Layout/Layout';

export const MatchChecklistIcons = {
  Matched: 'matched',
  Warning: 'warning',
  AI: 'ai',
} as const;

export type MatchChecklistIcon =
  (typeof MatchChecklistIcons)[keyof typeof MatchChecklistIcons];

export const MatchChecklistIconMap: Record<
  MatchChecklistIcon,
  { iconName: IconName; color: keyof typeof colors }
> = {
  matched: {
    iconName: IconNames.circleCheckFilled,
    color: 'dataVizForestGreen',
  },
  warning: {
    iconName: IconNames.alertFilled,
    color: 'dataVizYellow',
  },
  ai: {
    iconName: IconNames.intelligenceFilled,
    color: 'dataVizForestGreen',
  },
};

export interface MatchChecklistItemType extends PropsWithChildren {
  name: string;
  icon: MatchChecklistIcon;
}

export const MatchChecklistItem = ({
  name,
  icon,
  children,
}: MatchChecklistItemType) => {
  const { iconName, color } = MatchChecklistIconMap[icon];

  return (
    <Layout
      horizontalGutter="12px"
      position="left middle"
      name={`checklist-item-${name}`}
    >
      <CondensedMedium>
        <Flashy color={color} name={`checklist-item-${icon}`}>
          <Layout position="middle">
            <Icon name={iconName} />
          </Layout>
        </Flashy>
      </CondensedMedium>
      <CondensedLarge name={name}>{children}</CondensedLarge>
    </Layout>
  );
};
